import { SelectRadio } from '@/components/select-radio/SelectRadio';
import type { HttpApiServerType } from '@/services/http-api/httpApi';
import type { Example } from '@tarslib/types/lib/httpApi';
import React from 'react';

export type RequestSampleCodeVariantsProps = {
  variants: HttpApiServerType['codeSampleLanguages'][number]['variants'] | undefined;
  value: string | undefined;

  selectedRequestExampleKey: string | undefined;
  onSelectedRequestExampleKey: (key: string) => void;
  requestExamples: (Example & {
    key: string;
  })[];

  onChange: (value: string) => void;
};

export function RequestSampleCodeVariants(props: RequestSampleCodeVariantsProps) {
  const {
    requestExamples,
    variants,
    value,
    onChange,
    selectedRequestExampleKey,
    onSelectedRequestExampleKey,
  } = props;

  const options = React.useMemo(() => {
    return (
      variants?.map((variant) => ({
        label: variant.name ?? variant.key,
        value: variant.key,
      })) ?? []
    );
  }, [variants]);

  const isCustomRequestExample = React.useMemo(() => {
    return variants?.find((x) => x.key === value)?.code !== undefined;
  }, [variants, value]);

  const requestExamplesOptions = React.useMemo(() => {
    if (isCustomRequestExample) {
      return [];
    }
    return requestExamples.map((x) => {
      return {
        label: x.name,
        value: x.key,
      };
    });
  }, [requestExamples, isCustomRequestExample]);

  if (options.length < 2 && requestExamplesOptions.length < 2) {
    return null;
  }
  return (
    <div className="mx-4 overflow-x-auto pb-2">
      <SelectRadio
        type="radio"
        options={requestExamplesOptions}
        minShowItemCount={1}
        value={selectedRequestExampleKey ?? requestExamplesOptions[0]?.value}
        onChange={onSelectedRequestExampleKey}
        theme="dark"
        prefixNode={
          <SelectRadio
            type={requestExamplesOptions.length > 1 ? 'select' : 'radio'}
            options={options}
            minShowItemCount={1}
            value={value ?? options[0]?.value}
            onChange={onChange}
            theme="dark"
          />
        }
      />
    </div>
  );
}
